import { ContactForm } from '@components';
import { formPostPath } from '@paths';
import { usePardot } from '@hooks';

export const InlineContactForm: React.FC<{
  category?: string;
  pardotUrl?: string | null;
}> = ({ category, pardotUrl }) => {
  const { onSubmit } = usePardot(pardotUrl);
  return (
    <div className='-mx-4 bg-lightgray p-4 py-12 sm:mx-0'>
      <h2 className='text-center text-3xl'>
        <b>
          発注先探しの
          <br className='sm:hidden' />
          ご相談フォーム
        </b>
      </h2>
      <div className='my-7 text-center text-base'>
        発注ナビは貴社の発注先探しを
        <br className='sm:hidden' />
        徹底的にサポートします。
        <br />
        お気軽にご相談下さい。
      </div>
      <ContactForm
        collapsable
        formPostPath={formPostPath}
        category={category}
        onSubmit={onSubmit}
      />
    </div>
  );
};
